module.exports = __webpack_public_path__ + "static/media/wheatfield@2x.0ae28105.jpg";